<BaseModal v-model="isOpen" class="voucher-overlay" :bottomSheetOnMobile="true">
  <template #header>{{ $t('shopping.basket.checkout.vouchers')  }}</template>
  <div v-if="!cartVouchers.length && !isMobile" class="voucher-empty-state">
    <p class="voucher-empty-state__text">{{ $t('messages.checkout.cart.no_vouchers_available') }}</p>
    <!-- todo change the icon once arne is available -->
    <span class="voucher-empty-state__icon iconfont-voucher" aria-hidden="true"></span>
  </div>
  <NBCheckboxGroup v-else-if="cartVouchers.length" v-model="voucherSelection" :options="cartVouchers" valueKey="id">
    <template #default="{ option }">
      <div class="voucher-name">{{ option.name }}</div>
      <div class="voucher-code">{{ String($t('my_account.the_club.code', { code: option.code })).replace(/%/g, '') }}</div>
    </template>
  </NBCheckboxGroup>
  <template #footer>
    <div class="overlay-footer-title">{{ $t('messages.checkout.cart.add_voucher') }}</div>
    <NBFormInput
      v-model="voucherCodeInput"
      :label="$t('app.enter_code')"
      :error="vouchersError?.msg"
    />
    <div class="voucher-modal-footer">
      <button
        type="button"
        class="checkout-v2-btn"
        :class="{ disabled: !voucherCodeInput?.trim() || vouchersPending }"
        :disabled="!voucherCodeInput?.trim() || vouchersPending"
        @click="onRedeemClick"
      >{{ $t('app.voucher.voucher_btn') }}</button>
    </div>
  </template>
</BaseModal>
